import { del, get, post, put } from "../../axios";
import { generateQueryParams } from "./api-contracts";
import { responseIsSuccessful } from "../../global-helpers";
import { simpleResponse } from "../api-helpers";
import { ScopeOfWork } from "../../models/contract/ScopeOfWork";

export async function getScopes(contractId) {
  const queryParams = generateQueryParams(contractId);
  return await get(`work-scopes/${queryParams}`, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.scopes) {
        return res.data.scopes.map(s => new ScopeOfWork(s));
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function storeScope(scope) {
  return simpleResponse(
    post(
      "work-scopes",
      { work_scope_params: scope },
      window.localStorage.apiToken
    )
  );
}

export async function updateScope(scope) {
  return simpleResponse(
    put(
      `work-scopes/${scope.id}`,
      { work_scope_params: scope },
      window.localStorage.apiToken
    )
  );
}

export async function deleteScope(scope) {
  return simpleResponse(
    del(`work-scopes/${scope.id}`, window.localStorage.apiToken)
  );
}
